'use client';

import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { Controller, useForm } from 'react-hook-form';
import { PatternFormat } from "react-number-format";
import {
    TextField,
    Box,
} from '@mui/material';
import axios from 'axios';

import Footer from '@/components/Footer';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const schema = z.object({
    nome: z.string().min(1, 'Nome é obrigatório'),
    sobrenome: z.string().min(1, 'Sobrenome é obrigatório'),
    email: z.string().email('E-mail inválido'),
    celular: z.string().min(15, 'Celular inválido'),
});

type FormData = z.infer<typeof schema>;

export default function CadastroOportunidadeClient() {
    const {
        register,
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm<FormData>({
        resolver: zodResolver(schema),
    });

    const [enviado, setEnviado] = useState(false);

    useEffect(() => {
        if (enviado) {
            const timer = setTimeout(() => {
                setEnviado(false);
            }, 10000);
            return () => clearTimeout(timer);
        }
    }, [enviado]);

    const onSubmit = (data: FormData) => {
        setEnviado(true);

        const saida = {
            nome: data.nome + ' ' + data.sobrenome,
            telefones: [data.celular],
            email: data.email,
            empreendimentos: [30],
            idMidia: 'cmay9x75806ujjy064vs3fsde', 
            idRoleta: 'cmbpekiyx03n7bszeh94ofs7p'
        };

        axios.post('https://backend.evler.com.br:3336/form', saida, {
            headers: {
                'api-key': 'jQyTT5jbslAXMRlBFHQGwvZx48JbF3F87nSeU5q1ofFMZTmz1wNRkM8ta17u7LYh075LKO2QyreSDruAmj7PibZWcWxwn03Yt10dgKYtQT3gg7URi4p0UfvjmCMshdi3'
            }
        }).then(() => {
            toast.success('Formulário enviado com sucesso!');
            reset({
                nome: '',
                sobrenome: '',
                email: '',
                celular: '',
            });
        }).catch(() => {
            toast.error('Erro ao enviar o formulário. Tente novamente mais tarde.');
        });
    };

    return (
        <div className='overflow-x-hidden'>
            <div className="2xl:max-w-[1500px] w-[100vw] mx-auto md:px-10 px-0 mb-10 ">
                <div className="flex justify-between">
                    <div className="md:flex hidden gap-x-24 px-0 mt-8">
                        <div>
                            <img src={'/images/common/logo-forbli.webp'} alt={'Forbli Logo'} width={200} height={92} />
                        </div>
                        <div className="relative md:bottom-[195px] bottom-28 md:left-0 left-20 h-0">
                            <img src={'/images/common/icon-1.webp'} alt={'Ícone 1'} className="" width={370} height={92} />
                        </div>
                    </div>
                    <div className="md:hidden flex px-6 mt-8 ">
                        <div>
                            <img src={'/images/common/logo-forbli.webp'} alt={'Forbli Logo'} width={200} height={92} />
                        </div>
                        <div className="relative h-0 -right-20 bottom-6 ">
                            <img src={'/images/common/icon-1.webp'} alt={'Ícone 1'} className="" width={200} height={92} />
                        </div>
                    </div>
                    <div className="md:block hidden h-0 relative bottom-[90px] xl:left-12 left-0">
                        <img src={'/images/common/icon-2.webp'} alt={'Ícone 2'} className="w-[520px]" width={300} height={92} />
                    </div>
                </div>
                <div className="md:mt-20 mt-10 px-6">
                    <div className="w-full md:w-2/3">
                        <h1 className="md:text-[44px] text-[32px] md:block hidden leading-[40px] text-[#3a3a39] mb-8 font-bold ">
                            Seu apê de 2 quartos em<br />
                            Barbacena ou São João del-Rei com <span className="text-[#54d454]">parcelas menores<br /> que o aluguel está aqui!</span>
                        </h1>
                        <h1 className="md:text-[44px] md:hidden block text-[28px] leading-[40px] text-[#3a3a39] md:mb-8 mb-6 font-bold">
                            Seu apê de 2 quartos em<br />
                            Barbacena ou São João del-Rei com <span className="text-[#54d454]">parcelas menores<br /> que o aluguel está aqui!</span>
                        </h1>
                        <div className='bg-[#54d454] rounded-lg w-[350px] py-1 px-4 mb-8'>
                            <p className="md:text-[22px] text-[18px] leading-[27px] text-white font-bold ">
                                CADASTRE-SE e saia na frente
                            </p>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 px-6">
                    <div className="border-2 border-forbli-green rounded-xl p-4">
                        <Box className='relative z-20' component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ my: 2 }}>
                            <div className='md:flex hidden justify-end '>
                                <div className='h-0 relative z-30 bottom-24 left-28 animate-pop-in'>
                                    <img src={'/images/common/logo-mcmv-roda.webp'} alt={'cadastre'} className="relative animate-spin-slow" width={140} height={140} />
                                    <img src={'/images/common/logo-mcmv.webp'} alt={'cadastre'} className="relative bottom-[104px] left-[36px] " width={80} height={140} />
                                </div>
                            </div>

                            <div className='grid grid-cols-2 gap-x-4'>
                                <div className="">
                                    <label className="block text-sm px-2 text-gray-700 mb-1">Nome * </label>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        {...register('nome')}
                                        size='small'
                                        error={!!errors.nome}
                                        sx={{
                                            backgroundColor: '#eaeaea',
                                            borderRadius: 8,
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    border: '2px solid #54d454',
                                                    borderRadius: 8,
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: '#000',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#000',
                                                },
                                            },
                                        }}
                                    />
                                    {errors.nome && <span className="text-red-500">
                                        <InfoOutlineIcon sx={{ fontSize: 14 }} /> Insira um nome.
                                    </span>}
                                </div>
                                <div className="">
                                    <label className="block text-sm px-2 text-gray-700 mb-1">Sobrenome * </label>
                                    <TextField
                                        fullWidth
                                        size='small'
                                        variant="outlined"
                                        {...register('sobrenome')}
                                        error={!!errors.sobrenome}
                                        sx={{
                                            backgroundColor: '#eaeaea',
                                            borderRadius: 8,
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    border: '2px solid #54d454',
                                                    borderRadius: 8,
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: '#000',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#000',
                                                },
                                            },
                                        }}
                                    />
                                    {errors.sobrenome && <span className="text-red-500">
                                        <InfoOutlineIcon sx={{ fontSize: 14 }} /> Insira um sobrenome.
                                    </span>}
                                </div>
                            </div>
                            <div className="mt-6">
                                <label className="block text-sm px-2 text-gray-700 mb-1">Email * </label>

                                <TextField
                                    fullWidth
                                    type="email"
                                    {...register('email')}
                                    error={!!errors.email}
                                    size='small'
                                    sx={{
                                        backgroundColor: '#eaeaea',
                                        borderRadius: 8,
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                border: '2px solid #54d454',
                                                borderRadius: 8,
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#000',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#000',
                                            },
                                        },
                                    }}
                                />
                                {errors.email && <span className="text-red-500">
                                    <InfoOutlineIcon sx={{ fontSize: 14 }} /> Insira um endereço de email como exemplo@meusite.com.
                                </span>}
                            </div>

                            <div className="mt-6">
                                <label className="block text-sm px-2 text-gray-700 mb-1">Celular com Whatsapp *</label>
                                <Controller
                                    name="celular"
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                            <PatternFormat
                                                {...field}
                                                customInput={TextField}
                                                format="(##) #####-####"
                                                mask="_"
                                                fullWidth
                                                size='small'
                                                error={!!errors.celular}
                                                onValueChange={(values) => {
                                                    field.onChange(values.value)
                                                }}
                                                sx={{
                                                    backgroundColor: '#eaeaea',
                                                    borderRadius: 8,
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            border: '2px solid #54d454',
                                                            borderRadius: 8,
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: '#000',
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: '#000',
                                                        },
                                                    },
                                                }}
                                            />
                                            {errors.celular && <span className="text-red-500">
                                                <InfoOutlineIcon sx={{ fontSize: 14 }} /> Insira um número de telefone válido.
                                            </span>}
                                        </>
                                    )}
                                />
                            </div>

                            <button disabled={enviado} type="submit" className='rounded-full bg-forbli-green text-white w-[250px] py-1.5 mt-6'>
                                {enviado ? 'Enviado' : 'Enviar'}
                            </button>
                        </Box>
                        <div className='h-0 relative top-12 md:right-32 right-36 z-20'>
                            <img src={'/images/common/cta-register.webp'} alt={'cadastre'} className="relative md:bottom-[100px] bottom-[400px] animate-spin-slow" width={80} height={80} />
                        </div>
                    </div>

                    <div className='md:block hidden'>
                        <div className='h-0 absolute'>
                            <img src={'/images/common/icon-6.webp'} alt={'Ícone 6'} className="relative bottom-[100px]  " width={800} height={402} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='md:flex hidden justify-between 2xl:max-w-[1500px] mx-auto items-center relative bottom-20 overflow-x-hidden'>
                <div className="flex items-center 2xl:gap-x-6 gap-x-0 right-12 ">
                    <img src={'/images/common/icon-1.webp'} alt={'Ícone 1'} className="relative 2xl:right-12 right-0 bottom-16 " width={320} height={92} />
                    <div >
                        <p className='text-[18px] text-center'>Realização:</p>
                        <img src={'/images/common/logo-forbli.webp'} alt={'Forbli Logo'} width={200} height={92} />
                    </div>
                </div>

                <div>
                    <img src={'/images/common/logo-caixa.webp'} alt={'Caixa'} className='mx-auto' width={150} height={92} />
                    <img src={'/images/common/logo-mcmv-alt.webp'} alt={'Minha Casa Minha Vida'} className='mt-3' width={220} height={92} />
                </div>
                <div className="relative left-10">
                    <img src={'/images/common/icon-4.webp'} alt={'Ícone 4'} className="scale-x-[-1]" width={650} height={92} />
                </div>
            </div>
            <div className="md:block hidden relative h-0 bottom-48 right-16 ">
                <img src={'/images/common/icon-3.webp'} alt={'Ícone 3'} className="scale-y-[-1] scale-x-[-1]" width={350} height={140} />
            </div>
            <div className='md:hidden block'>
                <div className='flex justify-between mt-32'>
                    <div className='relative right-10 top-9'>
                        <img src={'/images/common/icon-1.webp'} alt={'Ícone 1'} className="" width={180} height={92} />
                    </div>
                    <div className='relative top-4 left-28 h-0'>
                        <div className='h-0 relative z-30 bottom-24 right-16 animate-pop-in'>
                            <img src={'/images/common/logo-mcmv-roda.webp'} alt={'cadastre'} className="relative animate-spin-slow" width={140} height={140} />
                            <img src={'/images/common/logo-mcmv.webp'} alt={'cadastre'} className="relative bottom-[102px] left-[34px] " width={80} height={140} />
                        </div>
                        <img src={'/images/common/icon-7.webp'} alt={'Ícone 3'} className="rotate-3" width={240} height={140} />
                    </div>
                </div>
                <div className='mb-8 relative z-10'>
                    <img src={'/images/common/icon-6.webp'} alt={'Ícone 6'} className="mx-auto" width={400} height={402} />
                </div>
                <div className="relative right-6">
                    <img src={'/images/common/icon-3.webp'} alt={'Ícone 3'} className="scale-y-[-1] scale-x-[-1]" width={180} height={140} />
                </div>
                <div >
                    <p className='text-[18px] text-center'>Realização:</p>
                    <img src={'/images/common/logo-forbli.webp'} alt={'Forbli Logo'} className='mx-auto' width={200} height={92} />
                </div>
                <div className="relative h-0 right-20 top-10">
                    <img src={'/images/common/icon-3.webp'} alt={'Ícone 3'} className="" width={170} height={140} />
                </div>
                <div className='mt-16'>
                    <img src={'/images/common/logo-caixa.webp'} alt={'Caixa'} className='mx-auto' width={120} height={92} />
                    <img src={'/images/common/logo-mcmv-alt.webp'} alt={'Minha Casa Minha Vida'} className='mt-3 mx-auto' width={180} height={92} />
                </div>
                <div className="flex justify-end px-3 relative -mt-16 top-[90px]">
                    <img src={'/images/common/icon-4.webp'} alt={'Ícone 4'} className="" width={220} height={92} />
                </div>
            </div>
            <Footer />
        </div>
    );
}
